import type { FilterDropdownOption } from './types';

/**
 * 필터 옵션을 정렬하는 함수
 *
 * @description
 * 1. 선택된 항목 우선
 * 2. 활성화된 항목
 * 3. 비활성화된 항목
 * 4. 같은 그룹 내에서는 알파벳 순 정렬
 *
 * @template T - 옵션의 값 타입
 * @param options - 정렬할 옵션 배열
 * @param selectedValues - 현재 선택된 값들
 * @returns 정렬된 옵션 배열
 */
export const sortFilterOptions = <T>(
  options: FilterDropdownOption<T>[],
  selectedValues: string[]
): FilterDropdownOption<T>[] => {
  return [...options].sort((a, b) => {
    const aSelected = selectedValues.includes(a.key);
    const bSelected = selectedValues.includes(b.key);

    if (aSelected && !bSelected) return -1;
    if (!aSelected && bSelected) return 1;

    if (a.disabled && !b.disabled) return 1;
    if (!a.disabled && b.disabled) return -1;

    return a.label.localeCompare(b.label);
  });
};
